export const JenkinsConfigType = {
    GLOBAL: 'GLOBAL',
    PRODUCT: 'PRODUCT',
    SUBPRODUCT: 'SUBPRODUCT'
}

export const awsToolData = {
    "Amazon GuardDuty":  {
    name: "GuardDuty",
    ymlFileName: 'REACT_APP_GUARD_DUTY_YML_FILE_NAME',
    stackName: "ArmorCodeGuardDutyStackSet",
    webHookName: "webhook-aws-guardduty"
    },
    "AWS Security Hub":  {
        name: "Security Hub",
        ymlFileName: 'REACT_APP_AWS_SECURITY_HUB_YML_FILE_NAME',
        stackName: "ArmorCodeSecurityHubStackSet",
        webHookName: "webhook-aws-securityhub"
    },
    "Amazon Inspector": {
        name: "Amazon Inspector",
        ymlFileName: 'REACT_APP_AMAZON_INSPECTOR_YML_FILE_NAME',
        stackName: "AmazonInspectorStackSet",
        webHookName: "webhook-aws-inspector"
    }
}
